import React from "react";
import { Box, Typography, Link, useMediaQuery } from "@mui/material";
import Logo from "/Images/Tennet (Putih) 1.svg";
import {
  Instagram,
  LinkedIn,
  Facebook,
  X,
} from "@mui/icons-material";
import Ojk from "/Images/OJK_Logo.png";
import Bapepti from "/Images/logo 27701 PT Tennet 1.svg";
import Kominfo from "/Images/logo PT TENNET 1.svg";
import Bappebti1 from '/Images/bappebti.svg';
import Kominfo2 from '/assets/komdigi.png';
import { useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const isMobile = useMediaQuery('(max-width: 767px)'); // Check if screen is mobile-sized
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    if (location.pathname !== path) {
      navigate(path);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleScrollToSection = (section) => {
    if (location.pathname !== "/usecase") {
      navigate("/usecase", { state: { section } });
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const styles = {
    container: {
      backgroundColor: "#E7E4E2",
      padding: isMobile ? "30px 20px" : "100px",
      color: "#FFFFFF",
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Column layout for mobile
      alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
      justifyContent: "space-between",
      flexWrap: "wrap",
      textAlign: isMobile ? "center" : "left", // Center text on mobile
    },
    logo: {
      width: "140px",
      marginBottom: "20px",
    },
    leftSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
      marginBottom: isMobile ? "20px" : "0", // Margin bottom for mobile
    },
    contactInfo: {
      color: "#214D73",
      marginBottom: "20px",
      fontSize: "1rem",
    },
    address: {
      color: "#6D6D6D",
      fontSize: "1rem",
      marginBottom: "20px",
    },
    socialIcons: {
      display: "flex",
      gap: "15px",
      marginTop: "10px",
      marginBottom: "20px",
      justifyContent: isMobile ? "center" : "flex-start", // Center icons on mobile
    },
    rightSection: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Column layout for mobile
      alignItems: isMobile ? "center" : "flex-start",
      justifyContent: isMobile ? "center" : "space-between",
      width: isMobile ? "100%" : "60%", // Full width on mobile
    },
    column: {
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
      color: "#6D6D6D",
      marginBottom: isMobile ? "20px" : "0", // Margin bottom for mobile
    },
    columnHeader: {
      marginBottom: "15px",
      fontWeight: "bold",
      fontSize: "1rem",
      color: "#214D73",
    },
    link: {
      marginBottom: "10px",
      color: "#6D6D6D",
      textDecoration: "underline",
      cursor: "pointer",
      textAlign: isMobile ? "center" : "left", // Center text on mobile
    },
    lowerSection: {
      borderTop: "0.1px solid rgba(255, 255, 255, 0.1)",
      marginTop: "20px",
      paddingTop: "20px",
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Column layout for mobile
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      color: "#E0DCD9",
      fontSize: "0.8rem",
      textAlign: "center", // Center text on mobile
    },
    certification: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Column layout for mobile
      alignItems: "center",
      gap: "20px",
      marginTop: isMobile ? "20px" : "0", // Margin top for mobile
    },
    termsLinks: {
      display: "flex",
      gap: "20px",
      color: "#B0B0B0",
      justifyContent: isMobile ? "center" : "left",
      marginBottom: "10px",
    },
    disclaimerText: {
      fontSize: "0.7rem",
      color: "#A5A5A5",
      lineHeight: "1.2rem",
      maxWidth: "520px",
      textAlign: "justify",
      margin: isMobile ? "0 auto" : "0", // Center text on mobile
    },
  };

  return (
    <Box style={styles.container}>
      {/* Left Section */}
      <Box style={styles.leftSection}>
        <img src={Logo} alt="Tennet Logo" style={styles.logo} />

        <Typography style={styles.contactInfo}>
          <span style={{ fontWeight: "bold" }}>Contact us </span> <br />
          <Link href="mailto:info@tennet.id" style={styles.link}>
            info@tennet.id
          </Link>
          <br />
          {/* <span style={{ color: "#6D6D6D" }}>+62 878 7800 0033</span> */}
        </Typography>

        <Typography style={styles.address}>
          <span style={{ fontWeight: "bold", color: "#214D73" }}>Address </span>{" "}
          <br />
          Millenium Centennial Center Floor 2th <br />
          Jl. Jend. Sudirman, Kav.25. DKI Jakarta
        </Typography>

        {/* Social Media Icons */}
        <Box style={styles.socialIcons}>
          <Link
            href="https://www.instagram.com/tennet_hq"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <Instagram style={{ color: "#2D669B" }} />
          </Link>
          <Link
            href="https://x.com/tennet_hq"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <X style={{ color: "#2D669B" }} />
          </Link>
          <Link
            href="https://www.linkedin.com/in/tennet-depository-indonesia-0a7274310"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <LinkedIn style={{ color: "#2D669B" }} />
          </Link>
          {/* <Link
            href="https://www.facebook.com/profile.php?id=100095051146361&ref=1"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <Facebook style={{ color: "#2D669B" }} />
          </Link> */}
          <Link
            href="https://www.tiktok.com/@tennet_hq"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <svg
              fill="#2D669B"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              width="24px"
              height="24px"
            >
              <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
            </svg>
          </Link>
        </Box>
      </Box>

      {/* Right Section */}
      <Box style={styles.rightSection}>
        <Box
          style={{
            display: "flex",
            flexDirection: isMobile ? "row" : "row", // Row layout on all views
            flexWrap: "wrap", // Allow wrapping on mobile
            justifyContent: "center", // Center content on mobile
            gap: isMobile ? "20px" : "100px", // Space between columns
            width: "100%", // Full width on mobile
          }}
        >
          <Box style={styles.column}>
            <Typography style={styles.columnHeader}>Products</Typography>
            <Link onClick={() => handleNavigate("/custody")} style={styles.link}>
              Custody
            </Link>
            <Link onClick={() => handleNavigate("/xcrow")} style={{ ...styles.link, display: "none" }}>
              Xcrow
            </Link>
            <Link onClick={() => handleNavigate("/otc")} style={{ ...styles.link, display: "none" }}>
              OTC
            </Link>
          </Box>
          <Box style={styles.column}>
            <Typography style={styles.columnHeader}>Solutions</Typography>
            <Link
              onClick={() => handleScrollToSection("business")}
              style={styles.link}
            >
              Our Business
            </Link>
            <Link
              onClick={() => handleScrollToSection("forWhom")}
              style={styles.link}
            >
              For whom
            </Link>
          </Box>
          <Box style={styles.column}>
            <Typography style={styles.columnHeader}>Company</Typography>
            <Link onClick={() => handleNavigate("/aboutus")} style={styles.link}>
              About us
            </Link>
            <Link onClick={() => handleNavigate("/whytennet")} style={styles.link}>
              Why Tennet
            </Link>
            <Link onClick={() => handleNavigate("/supported-coins")} style={styles.link}>
              Supported Coins
            </Link>
          </Box>
          {/* <Box style={styles.column}>
            <Typography style={styles.columnHeader}>Developers</Typography>
            <Link style={styles.link}>API</Link>
          </Box> */}
        </Box>
      </Box>


      {/* Lower Section */}
      <Box style={styles.lowerSection}>
        <Box>
          <Box style={styles.termsLinks}>
            <Link onClick={() => handleNavigate("/terms")} style={styles.link}>
              Terms & Conditions
            </Link>
         <Link onClick={() => handleNavigate("/privacy")} style={styles.link}>
              Privacy & Cookies
            </Link>
          </Box>
          <Typography style={styles.disclaimerText}>
            Cryptocurrency asset trading is a high-risk activity. Past performance does not indicate future results. Historical performance, expected return, and probability projections are provided for informational and illustrative purposes only. All cryptocurrency asset trading decisions are independent decisions made by the user.
          </Typography>
          <br />
          <Typography style={styles.disclaimerText}>
            Copyright © 2025 PT Tennet Depository Indonesia. All Rights Reserved.
          </Typography>
        </Box>

        {/* Certifications */}
        <Box style={styles.certification}>
          <Box style={styles.certification}>
            <Box style={{ display: "flex", flexDirection: "column", alignItems: isMobile ? "center" : "flex-end" }}>
              <Typography style={{ color: "#6D6D6D", fontSize: isMobile ? "0.875rem" : "1rem", marginBottom: "10px", textAlign: isMobile ? "center" : "end" }}>
                Powered and supervised by:
              </Typography>
              <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                <img src={Ojk} alt="OJK Logo" style={{ display: "none", maxWidth: isMobile ? "120px" : "180px", maxHeight: isMobile ? "60px" : "80px" }} />
                <img src={Bappebti1} alt="Bappebti Logo" style={{ display: "none", maxWidth: isMobile ? "120px" : "180px", maxHeight: isMobile ? "60px" : "80px" }} />
                <img src={Kominfo2} alt="Kominfo Logo" style={{ maxWidth: isMobile ? "130px" : "200px", maxHeight: isMobile ? "60px" : "70px" }} />
                <img src={Bapepti} alt="Bapepti Logo" style={{ maxWidth: isMobile ? "40px" : "50px", maxHeight: isMobile ? "60px" : "80px" }} />
                <img src={Kominfo} alt="Kominfo Logo" style={{ maxWidth: isMobile ? "100px" : "150px", maxHeight: isMobile ? "60px" : "80px" }} />
              </Box>
            </Box>
          </Box>

        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
